<template>
  <v-row>
    <v-col cols="12">
      <h1>Отчёт по блюдам</h1>
    </v-col>
    <v-col class="col-12 col-sm-2">
      <v-text-field label="Начиная с" v-model="dateFrom" type="date"></v-text-field>
    </v-col>
    <v-col class="col-12 col-sm-2">
      <v-text-field label="Заканчивая по" v-model="dateTo" type="date"></v-text-field>
    </v-col>
    <v-col cols="3" class="align-end justify-start d-flex">
      <v-btn @click="search()" class="mb-3">Поиск</v-btn>
    </v-col>
    <v-col class="col-12 col-sm-12 mt-diff mb-0">
      <v-checkbox label="Показать скрытые" v-model="showHidden"></v-checkbox>
    </v-col>
    <v-col class="col-12 col-sm-12 mt-diff">
      <products-select-modal v-model="selectedProducts" @input="search()" :products-categories="productCategories"></products-select-modal>
    </v-col>
    <v-col cols="12">
      <v-tabs v-model="tab" class="mb-6" v-if="this.selectedProducts.length === 0" show-arrows>
        <v-tab v-for="category in categories" :key="category.id" @change="changeCategory(category.id)">{{
            category.name
          }}
        </v-tab>
      </v-tabs>
      <v-data-table no-data-text="Нет блюд"
                    no-results-text="По заданному запросу ничего не найдено"
                    :headers="headers"
                    :items="products"
                    :options.sync="options"
                    :header-props="{sortIcon: 'icon-custom-arrow'}"
                    :footer-props="footerProps"
                    :loading="loading"
                    :items-per-page="100"
                    :custom-sort="customSort"
                    loading-text="Загрузка блюд... Подождите пожалуйста"
      >
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import draggable from 'vuedraggable'
import CategoryService from "../../api/CategoryService";
import ProductService from "../../api/ProductService";
import PromocodeProducts from "@/views/Promocode/Tables/PromocodeProducts.vue";
import ProductsModal from "@/components/ProductsModal.vue";
import PopularProductsModal from "@/components/PopularProductsModal.vue";
import ProductsSelectModal from "@/components/ProductsSelectModal.vue";


const date = new Date();
const dateNxt = new Date();
dateNxt.setMonth(dateNxt.getMonth() + 1);

export default {
  name: 'HomeIndex',
  components: {ProductsSelectModal, PromocodeProducts, draggable},
  data: () => ({
    customSort: (items, index, isDesc) => {
      const coef = isDesc[0] ? -1 : 1;

      if (!isDesc.length) {
        index = 'id';
      }


      items.sort((a, b) => {
        return parseInt(b[index]) < parseInt(a[index]) ? coef : -coef;
      });
      return items;
    },
    tab: 0,
    dateFrom: `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-01`,
    dateTo: `${dateNxt.getFullYear()}-${('0' + (dateNxt.getMonth() + 1)).slice(-2)}-01`,
    currentCategory: 0,
    showHidden: false,
    options: {},
    selectedProducts: [],
    productCategories: [],
    footerProps: {
      itemsPerPageText: 'Блюд на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [100]
    },
    headers: [
      {
        text: 'Блюдо',
        value: 'name',
        sortable: false
      },
      {text: 'Категория', value: 'category.name', sortable: false},
      {
        text: 'Количество заказов',
        value: 'order_count'
      },
      {
        text: 'Количество заказавших',
        value: 'order_user_count',
      },
      {
        text: 'Количество повторов',
        value: 'repeats_sum',
      },
      {
        text: 'Количество повторивших',
        value: 'repeats_count',
      },
      {
        text: 'Коэф повторов',
        value: 'repeats_percent',
        sortable: true,
      },
    ],

    loading: false,
    products: [],
    categories: [],
  }),
  mounted() {

    ProductService.listByCategory({}).then(response => {
      this.productCategories = response.data
    });

    CategoryService.list().then(response => {
      this.categories = response.data
      this.currentCategory = this.categories[0].id;
      this.search();
    })
  },
  watch: {},
  methods: {
    endDrag(items) {
      let params = {items: items}
      ProductService.updateSort(params).then(response => {

      })
    },
    changeCategory(id) {
      this.currentCategory = id;
      this.search();
    },
    search() {
      this.loading = true
      let params = {
        category: this.selectedProducts.length ? 0 : this.currentCategory,
        selectedProducts: this.selectedProducts.map(item => item.id),
        withChildren: true,
        type: 1,
        perPage: 60,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        showHidden: this.showHidden,
      }
      ProductService.report(params).then(response => {
        this.products = response.data.data.map((item) => {
          item.repeats_percent = (item.order_user_count ? item.repeats_count / item.order_user_count * 100 : 0).toFixed(2) + ' %';

          return item;
        })

        this.loading = false
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.page__grab-icon {
  &:hover {
    cursor: move;
  }
}

.mt-diff {
  margin-top: -40px;
  margin-bottom: -20px;
}
</style>
